var map = {
	"./css/home-style.css": "275b",
	"./icons/Setting-industry.png": "55c5",
	"./icons/additional-settings.png": "d3d1",
	"./icons/answer-email.png": "24d1",
	"./icons/applicant-hire-ratio.png": "e1df",
	"./icons/average-call.png": "2dfa",
	"./icons/average-time-hire.png": "cb53",
	"./icons/avg-candidates.png": "8303",
	"./icons/avg-interviews-offer.png": "bf97",
	"./icons/bar.png": "6859",
	"./icons/calendar.png": "6c68",
	"./icons/call-connect.png": "caf8",
	"./icons/candidate-16.png": "1f39",
	"./icons/candidate-24.png": "d09d",
	"./icons/candidate-white.png": "1e62",
	"./icons/candidates-hvr.png": "0387",
	"./icons/candidates-hvr1.jpg": "5848",
	"./icons/candidates.png": "1ac8",
	"./icons/candidates1.jpg": "a5d5",
	"./icons/ceo.png": "79c5",
	"./icons/chart.png": "6eff",
	"./icons/customer-hover.png": "2695",
	"./icons/customer-white.png": "4644",
	"./icons/customer.png": "5528",
	"./icons/dashboard-hover.png": "31ce",
	"./icons/dashboard-white.png": "13bb",
	"./icons/dashboard.png": "4381",
	"./icons/domain-icon.png": "da8b",
	"./icons/domain-working-in-lap.png": "b3c3",
	"./icons/duplicate.png": "92a5",
	"./icons/effectiveness.png": "cb8c",
	"./icons/email-settings.png": "08ca",
	"./icons/email-tools.png": "e528",
	"./icons/envelope-with-pencil.png": "0934",
	"./icons/excel-24.png": "f312",
	"./icons/existing-templates.png": "f12b",
	"./icons/facebook-icon.png": "9795",
	"./icons/failure.png": "a35f",
	"./icons/faq.png": "5095",
	"./icons/folder.png": "16cf",
	"./icons/handshake.png": "2052",
	"./icons/hire-source.png": "9809",
	"./icons/import-file.png": "6e6a",
	"./icons/interview (1).png": "3725",
	"./icons/interview-white.png": "9bee",
	"./icons/job-bag.png": "7aa9",
	"./icons/job-hover.png": "c488",
	"./icons/job-suitcase.png": "fd25",
	"./icons/job.png": "9d63",
	"./icons/jobprofile-white.png": "1a33",
	"./icons/kpi-icon.png": "604a",
	"./icons/mail-icon.png": "714e",
	"./icons/mail.png": "d557",
	"./icons/meeting-16.png": "5c0d",
	"./icons/meeting-blue.png": "f64e",
	"./icons/meeting-white.png": "f0cc",
	"./icons/minus.png": "35b8",
	"./icons/myinbox-hover.png": "297c",
	"./icons/myinbox-white.png": "f5eb",
	"./icons/myinbox.png": "84de",
	"./icons/offers-accepted.png": "4dbb",
	"./icons/offers-denied.png": "ed98",
	"./icons/other-reports-icon.png": "1c2c",
	"./icons/pink.gif": "b55a",
	"./icons/productivity.png": "dc12",
	"./icons/quality-of-hire.png": "83f2",
	"./icons/questionnaire.png": "5418",
	"./icons/rate.png": "0595",
	"./icons/recruit-32.png": "a936",
	"./icons/recruit-white.png": "a35f1",
	"./icons/recruiter-performance.png": "de77",
	"./icons/register.png": "8494",
	"./icons/resume.png": "5e4f",
	"./icons/scope-icon.png": "8eeb",
	"./icons/settings-border.png": "c748",
	"./icons/settings-gears.png": "e6b6",
	"./icons/settings-tools-white.png": "3305",
	"./icons/share-16.png": "e756",
	"./icons/share.png": "4148",
	"./icons/sigma.png": "dbe7",
	"./icons/sms-icon.png": "4da4",
	"./icons/sourcing-channel.png": "3b46",
	"./icons/statistics-white.png": "c182",
	"./icons/support.png": "60b9",
	"./icons/talentidentified-hire-ratio.png": "7435",
	"./icons/technology-skills-icons.png": "4835",
	"./icons/template-management.png": "89ae",
	"./icons/time-zone-icon.jpg": "ee47",
	"./icons/tool-demo-white.png": "d46b",
	"./icons/tooldemo-white.png": "2538",
	"./icons/tools-settings.png": "6f62",
	"./icons/tools.png": "41ff",
	"./icons/twitter-icon.png": "2055",
	"./icons/user-silhouette-hover.png": "5e5a",
	"./icons/user-silhouette.png": "b93b",
	"./icons/user.png": "3e52",
	"./icons/user1.png": "05f8",
	"./icons/user2.png": "a717",
	"./icons/user3.png": "38ff",
	"./icons/user4.png": "2dd2",
	"./icons/user5.png": "475b",
	"./icons/user6.png": "83cd",
	"./icons/value-16.png": "41f7",
	"./icons/value-blue.png": "0af9",
	"./icons/value-white.png": "8b07",
	"./icons/web-design-hover.png": "4e60",
	"./icons/web-design.png": "0221",
	"./icons/working-with-laptop-16.png": "95e5",
	"./icons/working-with-laptop-24.png": "e6c0",
	"./icons/working-with-laptop-hover.png": "3a7b",
	"./icons/working-with-laptop.png": "50a8",
	"./images/Pdf.jpg": "399b",
	"./images/Service-3.jpg": "69f4",
	"./images/banner1.jpg": "d15f",
	"./images/banner2.jpg": "db49",
	"./images/banner3.jpg": "114b",
	"./images/checked.png": "4f4e",
	"./images/coins.png": "a83f",
	"./images/file2.png": "c05d",
	"./images/fixed-cost.png": "09cc",
	"./images/flexibility.png": "dda4",
	"./images/hidden-costs.png": "36f7",
	"./images/innerpages_banner1.jpg": "9a29",
	"./images/landing-page-background01.png": "114a",
	"./images/loader.svg": "a72f",
	"./images/microsoftexcel.jpg": "a9dc",
	"./images/our-values.jpg": "b01a",
	"./images/saaa-cloud-model.png": "25c7",
	"./images/talent-turbo-logo1.png": "ee12",
	"./images/talentturbo.png": "33c0",
	"./images/talentturbo1.png": "a175",
	"./images/talentturbo10.png": "e667e",
	"./images/technologies.png": "a255",
	"./images/trial-period.png": "5fc9",
	"./images/word.jpg": "f90e",
	"./logo.png": "cf05",
	"./socialmedia/facebook-icon1.png": "a645",
	"./socialmedia/facebook-icon2.png": "09f1",
	"./socialmedia/linkedin-icon1.png": "bf38",
	"./socialmedia/linkedin-icon2.png": "abd8",
	"./socialmedia/twitter-icon1.png": "0d90",
	"./socialmedia/twitter-icon2.png": "0da4",
	"./videos/tool-demo/AddCandidate.mp4": "0e43",
	"./videos/tool-demo/AddJob.mp4": "9984",
	"./videos/tool-demo/CandidateList.mp4": "8655",
	"./videos/tool-demo/JobList.mp4": "c9d6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";